const messages = {
  title: "Anmelden",
  description:
    "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.<br/></br><b>Sind Sie neu hier?</b><br/></br>Erstellen Sie dann zunächst Ihr neues Benutzerkonto über die Funktion REGISTRIEREN.<br/></br>Sie werden dann automatisch eingeloggt.",
  info: "",
  buttons: {
    action: "Anmelden / Registrieren",
    back: "ZURÜCK",
    changeLanguage: "Sprache ändern",
    start: "Starten",
  },
  languageSelect: {
    label: "Language Selection",
    description:
      "Bitte wählen Sie Ihre Sprache/ Veuillez choisir votre langue/ Selezionare la lingua",
    start: {
      deCH: "Deutsch",
      frCH: "Französisch",
      itCH: "Italienisch",
    },
  },
};

export default {
  messages,
};
